import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
//REDUX
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
// import the two exports from the last code snippet.
import { persistor, store } from './redux/store';
import LoadingIndicator from './shared/LoadingIndicator/loadingIndicator';
//UTILS
import './utils/i18n';

import { useEffect } from 'react';
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from 'react-router-dom';

ReactDOM.createRoot(document.getElementById('root')).render(
	<Provider store={store}>
		<PersistGate loading={<LoadingIndicator />} persistor={persistor}>
			<App />
		</PersistGate>
	</Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
